import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import MedienPopupSlider from '../components/MedienPopupSlider';
import Header_3 from '../headers/Header_3';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import TitleTextButton from '../modules/TitleTextButton';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import SEO from '../components/Seo';
import Button from '../components/Button';
import Header_2 from '../headers/Header_2';

export const Medien = () => {
    const [show, setShow] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const handleOpenModal = (item) => {
        console.log('Selected item:', item);

        const scrollY = window.scrollY;

        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';

        setSelectedItem(item);
        setShow(true);
    };

    const handleCloseModal = () => {
        const scrollY = document.body.style.top;

        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';

        window.scrollTo({
            top: parseInt(scrollY || '0') * -1,
            behavior: 'instant' // supported in modern browsers
        });

        setShow(false);
        setSelectedItem(null);
    };

    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [medienData, setMedienData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/medien-page?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Video]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Metadaten]=*");



            // &populate[Modul][on][modules.faq][populate][FAQ_Data][populate]=*
            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][siedlungen_kategorien][populate]=*

            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true


            // populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setMetaData(data?.data?.Metadaten);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    const getMedienData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/medien-posts?pagination[limit]=100&sort[0]=sortOrder&populate[Bild][populate]=*&populate[PDF][populate][PDF][populate]=*");

            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setMedienData(data.data);
                setMetaData(data?.data?.Metadaten);
            }
        }
        catch (error) {
            console.error(error);
        }

    }

    useEffect(() => {
        getPageData();
        getMedienData();
    }, [])


    const titleModules = modules?.filter(
        (module) => module.__component === "modules.short-titel-titel-text-button"
    );

    const firstTitleModule = titleModules?.[0];
    const secondTitleModule = titleModules?.[1];

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {show && selectedItem && (
                <div className="modal medien_modal show d-block">
                    <div className="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button className="btn-close" onClick={handleCloseModal}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" nighteye="disabled">
                                        <rect width="64" height="64" rx="32" fill={`var(--pink)`} />
                                        <rect x="19.3203" y="21.1396" width="2.56" height="33.28" rx="1.28" transform="rotate(-45 19.3203 21.1396)" fill="white" />
                                        <rect x="42.8594" y="19.3301" width="2.56" height="33.28" rx="1.28" transform="rotate(45 42.8594 19.3301)" fill="white" />
                                    </svg>
                                </button>
                                <div className='popup-container'>
                                    <div className='row'>
                                        <div className='col-lg-6 contnet-col'>
                                            {/* <div className='post_date text-darkgrey fs_26 mb-3'>12.08.2025</div> */}
                                            {selectedItem?.Publikation && <div className='post_date text-darkgrey fs_26 mb-3'>
                                                {selectedItem?.Publikation
                                                    ? new Date(selectedItem.Publikation).toLocaleDateString('de-DE', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                    })
                                                    : ''}
                                            </div>}
                                            <h2 className="text-pink fs_50 fw-600">{selectedItem?.Titel}</h2>
                                            <h3 className="text-black fs_40 fw-600">{selectedItem?.Untertitel}</h3>
                                            {selectedItem?.Text && <p>{selectedItem?.Text}</p>}
                                            <div className='download_pdf_list'>
                                                {selectedItem?.PDF?.map(
                                                    (pdfItem, pdfIndex) => (
                                                        <a
                                                            key={pdfIndex}
                                                            href={`https://backend.bgzurlinden.ch${pdfItem?.PDF?.url}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className='pdf_download'
                                                        >
                                                            {pdfItem?.button_text}

                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32" fill="none">
                                                                <path d="M11.9999 26.46C11.7285 26.46 11.4571 26.36 11.2439 26.155L2.01608 17.485C1.55566 17.055 1.52658 16.32 1.94338 15.845C2.36018 15.37 3.07262 15.34 3.53304 15.77L11.9999 23.735L20.4668 15.77C20.9272 15.34 21.6348 15.375 22.0565 15.845C22.4733 16.32 22.4393 17.05 21.9838 17.485L12.756 26.16C12.5427 26.36 12.2713 26.46 11.9999 26.46Z" fill={`var(--${pdfItem?.button_farbe?.split(" ")[0]})`} />
                                                                <path d="M11.9999 26.46C11.3796 26.46 10.8756 25.94 10.8756 25.3V1.16C10.8756 0.519999 11.3796 0 12 0C12.6203 0 13.1244 0.519999 13.1244 1.16V25.3C13.1244 25.945 12.6203 26.46 11.9999 26.46Z" fill={`var(--${pdfItem?.button_farbe?.split(" ")[0]})`} />
                                                                <path d="M22.8756 32H1.12439C0.504039 32 0 31.48 0 30.84C0 30.2 0.504039 29.68 1.12439 29.68H22.8756C23.496 29.68 24 30.2 24 30.84C24 31.48 23.496 32 22.8756 32Z" fill={`var(--${pdfItem?.button_farbe?.split(" ")[0]})`} />
                                                            </svg>
                                                        </a>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                        <div className='col-lg-6 image-col'>
                                            <MedienPopupSlider images={selectedItem?.Bild} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-genossenschaft" sendTitle={false} />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-3-titel-text-bild" && (
                            <Header_3 module={module} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-genossenschaft medien-banner-sec" activePage="medien" sendTitle={false} showInfo={true} />
                        )}
                    </React.Fragment>
                ))
            )}

            {firstTitleModule && (
                <section
                    className={`pt-pb-10 sec-pink-color ${firstTitleModule?.Padding_Top ? "" : "pt-0"
                        } ${firstTitleModule?.Padding_Bottom ? "" : "pb-0"
                        } ${firstTitleModule?.grauer_Hintergrundfarbe
                            ? "sec-bg-grey"
                            : ""
                        }`}
                >
                    <div className="container">
                        <TitleTextButton
                            data={firstTitleModule}
                            shortTitle={firstTitleModule?.Kurztitel}
                            title={firstTitleModule?.Titel}
                            text={firstTitleModule?.Text}
                            buttons={firstTitleModule?.Button}
                            component={firstTitleModule?.Komponente}
                            pdf={firstTitleModule?.PDF}
                        />
                    </div>
                </section>
            )}

            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {/* {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-pink-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        } */}
                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="pink" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        }
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}


            <section className='sec-medien sec-pink-color pt-pb-10 pt-0'>
                <div className="container">
                    <div className='row medien_list'>
                        {medienData?.map((item, index) => (
                            <div key={index} className='col-sm-6 col-lg-4 mt-4 mt-lg-5 col-item'>
                                <Link onClick={() => handleOpenModal(item)} className='col-inner'>
                                    <figure>
                                        {item?.Bild[0]?.url && <img src={`https://backend.bgzurlinden.ch${item?.Bild[0]?.url}`} alt='#' />}
                                    </figure>
                                    <div className='figcaption '>
                                        {item?.Publikation && <span className='post-date position-static mb-2 d-block'>
                                            {new Date(item?.Publikation).toLocaleDateString('de-DE', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                            })}
                                        </span>}
                                        <h4 className="fs_26 fw-700 text-darkgrey">{item?.Titel}</h4>
                                        <p className="fw-550 text-darkgrey">{item?.Text}</p>
                                        {/* {item?.Publikation && <span className='post-date'>
                                            {new Date(item?.Publikation).toLocaleDateString('de-DE', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                            })}
                                        </span>} */}

                                        <div className="button round_btn btn-pink-color">lesen &nbsp;
                                            <span>
                                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit" />
                                                    <path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit" />
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                    {/* <div class="btn-container d-flex justify-content-center mt-4 mt-lg-5">
                <Link to='/' className='button border-btn btn-theme-color'>mehr</Link>
            </div> */}
                </div>
            </section>

            {!isLoading && secondTitleModule && (
                <section
                    className={`pt-pb-10 sec-pink-color ${secondTitleModule?.Padding_Top ? "" : "pt-0"
                        } ${secondTitleModule?.Padding_Bottom ? "" : "pb-0"
                        } ${secondTitleModule?.grauer_Hintergrundfarbe
                            ? "sec-bg-grey"
                            : ""
                        }`}
                >
                    <div className="container">
                        <TitleTextButton
                            data={secondTitleModule}
                            shortTitle={secondTitleModule?.Kurztitel}
                            title={secondTitleModule?.Titel}
                            text={secondTitleModule?.Text}
                            buttons={secondTitleModule?.Button}
                            component={secondTitleModule?.Komponente}
                            pdf={secondTitleModule?.PDF}
                            medienSection={true}
                        />
                    </div>
                </section>
            )}
        </div>
    )
}